import { useAgentOfficesWithPagingQuery } from "queries";

const useAgentOfficeResidualsDdlColumn = () => {
	const { mutateAsync: getAgentOffices } = useAgentOfficesWithPagingQuery();

	const loadOptions = async (search, prevOptions, { page }) => {
		try {
			const newUsers = await getAgentOffices({
				pattern: search,
				page_index: page,
			});

			const hasMore =
				prevOptions.length + newUsers.items.length < newUsers.count;

			return {
				options: newUsers.items,
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		} catch {
			return { options: [] };
		}
	};

	return {
		name: "agentOfficeDdl",
		type: "select" as const,
		loadOptions,
		getOptionLabel: option => option.name,
		getOptionValue: option => option.id,
		placeholder: "Agent Office",
	};
};

export default useAgentOfficeResidualsDdlColumn;
